const ResourceLiveFubo = () =>
  import('@/views/main/inspect/resourceLiveFubo/ResourceLiveFubo.vue')
export default {
  path: '/main/inspect/resourceLiveFubo',
  name: 'ResourceLiveFubo',
  component: ResourceLiveFubo,
  children: []
}
